export default class WSPromotion {
	constructor({
		promotionId,
		promotionName,
		promoCode,
		discountAmount,
	}) {
		this.promotionId = promotionId;
		this.promotionName = promotionName;
		this.promoCode = promoCode;
		this.discountAmount = discountAmount;
	}

	static fromBackoffice(data) {
		const result = new WSPromotion(data);
		return result;
	}

	toBackoffice() {
		return this;
	}

	static fromSerialized(data) {
		const result = new WSPromotion(data);
		return result;
	}

	toResolver() {
		const forGraphql = Object.freeze(this);
		return forGraphql;
	}
}

export const WSPromotionFragmentType = [];

export const WSPromotionFragment = `
	promotionId: Int!
	promotionName: String!
	promoCode: String!
	discountAmount: Int!
`;

export const InputWSPromotionType = [
	...WSPromotionFragmentType,
	`
		input InputWSPromotion {
			${WSPromotionFragment}
		}
	`,
];

export const WSPromotionType = [
	...WSPromotionFragmentType,
	`
		type WSPromotion {
			${WSPromotionFragment}
		}
	`,
];
